export const types = {
  SET_ANIMATED_LOGO_OPENING: 'SET_ANIMATED_LOGO_OPENING',
  SET_ANIMATED_LOGO_CLOSING: 'SET_ANIMATED_LOGO_CLOSING',
  RESET_LOGO: 'RESET_LOGO',
  SET_HAS_NAVIGATED: 'SET_HAS_NAVIGATED',
  SET_INITIAL_ROUTE: 'SET_INITIAL_ROUTE',
}
